import React from 'react';
import { MdArrowBack, MdArrowForward } from 'react-icons/md';
import Link from 'next/link';
import { useRouter } from '../../../hooks/useCustomRouter';

interface ButtonMovePageProps {
  showNextButton: boolean;
  showPrevButton: boolean;
  onClickNext: () => void;
  onClickPrev: () => void;
  className?: string;
  labelPrev?: string;
  labelNext?: string;
  prevLink: string;
  nextLink: string;
}

const ButtonMovePage = ({
  showNextButton,
  showPrevButton,
  onClickNext,
  onClickPrev,
  className,
  labelPrev = 'Sebelumnya',
  labelNext = 'Selanjutnya',
  prevLink,
  nextLink,
}: ButtonMovePageProps) => {
  const router = useRouter();

  return (
    <div className={`flex ${className}`}>
      <>
        {showPrevButton ? (
          <Link
            href={{
              pathname: prevLink,
              query: router.query?.variant
                ? {
                    variant: router.query?.variant,
                  }
                : {},
            }}
            onClick={onClickPrev}
            className="flex-1 h-12 lg:h-24  bg-gray-200  mb-12 uppercase flex items-center justify-center text-center text-reliableBlack text-xs lg:text-xl font-bold transition-colors hover:text-slate-400  hover:cursor-pointer"
          >
            <MdArrowBack
              className="mr-4 transition-colors hover:text-slate-400  hover:cursor-pointer"
              color="reliableBlack"
              size={24}
            />
            {labelPrev}{' '}
          </Link>
        ) : (
          ''
        )}

        {showNextButton ? (
          <Link
            href={{
              pathname: nextLink,
              query: router.query?.variant
                ? {
                    variant: router.query?.variant,
                  }
                : {},
            }}
            onClick={onClickNext}
            className="flex-1 h-12 lg:h-24 bg-reliableBlack mb-12 uppercase flex items-center justify-center text-center text-white text-xs lg:text-xl font-bold transition-colors hover:text-slate-400  hover:cursor-pointer"
          >
            {labelNext}{' '}
            <MdArrowForward
              className="ml-4 transition-colors hover:text-slate-400  hover:cursor-pointer"
              color="#ffffff"
              size={24}
            />
          </Link>
        ) : (
          ''
        )}
      </>
    </div>
  );
};
export default ButtonMovePage;
